export { default } from "./FlashBanner";
